import { takeEvery, call, put } from 'redux-saga/effects';
import {
  sendGetAuthAccountDataRequest,
  updateAuthAccountData,
  changeHasAuthorized
} from '../../../../common/reducers/states/authAccount';

import { updateData as updateBalanceData } from '../../../../../../common/reducers/data/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import UserService from '../../../../services/UserService';

function* getAccount() {
  try {
    const result = yield call(timeoutCall, UserService.getMe);
    if (result.response) {
      if (result.response.status === 200) {
        yield put(updateAuthAccountData(result.restructureData.profile));
        yield put(
          updateBalanceData(
            'userFlowFundsModule.states.authAccountBalance',
            result.restructureData.balance
          )
        );
        yield put(changeHasAuthorized(true));
      }
      if (result.response.status === 401) {
        yield put(changeHasAuthorized(false));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export default function getSaga() {
  return [takeEvery(sendGetAuthAccountDataRequest().type, getAccount)];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/reducers/static/states/sagas/authAccountSaga.js